import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { HiStar } from 'react-icons/hi'
import { FaTrophy } from 'react-icons/fa'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbPair } from '../../utils/seoUtils'
import './HonoraryAwards.css'

function HonoraryAwards() {
  const { t } = useTranslation()

  const breadcrumbItems = useMemo(
    () => seoBreadcrumbPair(t('common.home'), t('common.honoraryAwards'), 'honorary-awards'),
    [t]
  )

  // Mock data
  const awards = []

  return (
    <div className="honorary-awards-page">
      <SEO 
        title={t('common.honoraryAwards')}
        description={t('honoraryAwards.description', 'Honorary awards of SUMA International')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <div className="honorary-awards-hero">
          <HiStar className="hero-icon" />
          <h1>{t('common.honoraryAwards')}</h1>
          <p className="honorary-awards-intro">
            {t('honoraryAwards.intro', 'SUMA International recognizes outstanding contributions to martial arts through various honorary awards and distinctions.')}
          </p>
        </div>

        <section className="awards-section">
          <h2>{t('honoraryAwards.types', 'Types of Awards')}</h2>
          <div className="awards-types">
            <div className="award-type-card">
              <FaTrophy className="award-icon" />
              <h3>{t('honoraryAwards.lifetime', 'Lifetime Achievement')}</h3>
              <p>{t('honoraryAwards.lifetimeText', 'Recognition for lifelong dedication to martial arts')}</p>
            </div>
            <div className="award-type-card">
              <HiStar className="award-icon" />
              <h3>{t('honoraryAwards.excellence', 'Excellence Award')}</h3>
              <p>{t('honoraryAwards.excellenceText', 'Award for exceptional performance and contribution')}</p>
            </div>
            <div className="award-type-card">
              <FaTrophy className="award-icon" />
              <h3>{t('honoraryAwards.service', 'Service Award')}</h3>
              <p>{t('honoraryAwards.serviceText', 'Recognition for outstanding service to the community')}</p>
            </div>
          </div>
        </section>

        <section className="awards-section">
          <h2>{t('honoraryAwards.recipients', 'Award Recipients')}</h2>
          <div className="recipients-list">
            {awards.length > 0 ? (
              awards.map(award => (
                <div key={award.id} className="award-card">
                  <HiStar className="award-badge" />
                  <h3>{award.recipient}</h3>
                  <p className="award-type">{award.type}</p>
                  <p className="award-year">{award.year}</p>
                  <p className="award-description">{award.description}</p>
                </div>
              ))
            ) : (
              <div className="no-awards">
                <p>{t('honoraryAwards.noAwards', 'Award recipients will be displayed here as awards are presented.')}</p>
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  )
}

export default HonoraryAwards
